import React, { useMemo } from 'react';

import linkOutIcon from 'images/directory/link_out_icon.svg';

import Pill from '@components/Pill';
import { topic_landing_path } from '@routes';
import { ProfileEntity } from '@utils/backend-api/subscriber_directory';

interface SectionProps {
  entities: ProfileEntity[];
  fieldName: string;
  param: string;
  pluralFieldName: string;
  profileName: string;
}

const Section = ({ entities, fieldName, param, pluralFieldName, profileName }: SectionProps) => {
  const numberofCommonEntities = useMemo(() => entities?.filter((t) => t.match).length, [entities]);

  return (
    <div className="section-detail with-pills">
      {numberofCommonEntities > 0 && (
        <div className="common-intro">
          You and {profileName} have {numberofCommonEntities}{' '}
          {numberofCommonEntities > 1 ? pluralFieldName : fieldName} in common
        </div>
      )}
      {entities.map((entity, id) =>
        param === 'topics' ? (
          <Pill
            href={topic_landing_path(entity.value.toLowerCase())}
            text={entity.value}
            icon={linkOutIcon}
            key={id}
          />
        ) : (
          <Pill text={entity.value} key={id} />
        )
      )}
    </div>
  );
};

export default Section;
